import { useAppSelector } from "@/store/hooks";

/**
 * /auth/me が返す実効権限に基づいて、設定画面の操作可否を判定する。
 * 権限取得前・取得失敗時は安全側に倒し、更新・削除操作を許可しない。
 */
export const useCan = (): ((actionKey: string) => boolean) => {
  const capabilities = useAppSelector((state) => state.auth.capabilities);
  const loaded = useAppSelector((state) => state.auth.capabilitiesLoaded);

  return (actionKey: string) =>
    loaded && capabilities.includes(actionKey);
};

export default useCan;
